import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const createPayment = createAsyncThunk(
  "payment/create",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.createPayment}`;
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const updatePaymentStatus = createAsyncThunk(
  "payment/updateStatus",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.updatePaymentStatus}`;
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const getPaymentTypes = createAsyncThunk(
  "payment/getPaymentTypes",
  async () => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getPaymentTypes}`;
    try {
      const response = await axiosGet(`${url}`);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const getPaymentMethodTypes = createAsyncThunk(
  "payment/getPaymentMethodTypes",
  async () => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getPaymentMethodTypes}`;
    try {
      const response = await axiosGet(`${url}`);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);
